import { RefObject, useEffect } from 'react';

/**
 * Calls the handler when a click is detected outside the ref element.
 */
export function useOnClickOutside(ref: RefObject<HTMLElement>, handler: (event: MouseEvent) => void) {
    useEffect(() => {
        const listener = (event: MouseEvent) => {
            // Do nothing if clicking ref's element or descendent elements
            if (!ref.current || !(event.target instanceof Node) || ref.current.contains(event.target)) {
                return;
            }

            handler(event);
        };

        document.addEventListener('click', listener);

        return () => {
            document.removeEventListener('click', listener);
        };
    }, [ref, handler]);
}
